import { gql, useQuery } from '@apollo/client'

import {
  CommentsConnectionFragmentDoc,
  TradeBoxFragmentDoc,
  UserTradeDetailQuery,
  UserTradeDetailQueryVariables,
} from '@/clients/utoniq-core/schema'
import { useCurrentUser, useRouter } from '@/core'
import { makeViewModel } from '@/core/architecture'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { user: currentUser } = useCurrentUser()
  const { router } = useRouter<{ tradeNegotiationId: string }>()
  const { data, loading, fetchMore } = useQuery<
    UserTradeDetailQuery,
    UserTradeDetailQueryVariables
  >(QUERY, {
    variables: { tradeNegotiationId: router.query.tradeNegotiationId },
    returnPartialData: true,
  })

  return {
    state: {
      loading,
      currentUser,
      hasNextPage: !!data?.tradeNegotiation?.comments?.pageInfo?.hasNextPage,
      messages: data?.tradeNegotiation?.comments ?? null,
      trade: data?.tradeNegotiation ?? null,
    },
    actions: {
      async onFetchMore() {
        await fetchMore({
          variables: {
            tradeNegotiationId: router.query.tradeNegotiationId,
            pageInput: {
              cursor: data?.tradeNegotiation.comments?.pageInfo.endCursor,
              limit: 30,
            },
          },
        })
      },
    },
  }
})

const QUERY = gql`
  query UserTradeDetail($tradeNegotiationId: ID!, $pageInput: PageInput) {
    tradeNegotiation(id: $tradeNegotiationId) {
      expiredAt
      formattedExpiredAt @client
      ...TradeBox
      comments(pageInput: $pageInput) {
        ...CommentsConnection
      }
    }
  }
  ${TradeBoxFragmentDoc}
  ${CommentsConnectionFragmentDoc}
`
